var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.getAllCheckups),function(el){return _c('Single',{key:el.id,class:`checkUp-${el.id}`,attrs:{"category":"checkUp","data":el}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }